module.exports = __webpack_public_path__ + "static/media/banner_logo.30903406.png";